import JobData from 'model/JobData';

export const hasMapCoordinates = (job: JobData | null) =>
  job?.latitude && job?.longitude;
